import { hoverTip } from './over-tip'
import type { App } from 'vue'

/**
 * 注册全局指令
 */
export function registerDirectives(app: App) {
  app.directive('hover-tip', hoverTip)
}

// 默认导出，用于自动注册
export default {
  install(app: App) {
    registerDirectives(app)
  }
}
